export default __webpack_public_path__ + "static/media/id-mapping-img.cbb48af5.svg";